import { render, staticRenderFns } from "./Static.vue?vue&type=template&id=1d9da8e8&scoped=true&"
import script from "./Static.vue?vue&type=script&lang=js&"
export * from "./Static.vue?vue&type=script&lang=js&"
import style0 from "./Static.vue?vue&type=style&index=0&id=1d9da8e8&lang=scss&scoped=true&"
import style1 from "./Static.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9da8e8",
  null
  
)

export default component.exports